import React from 'react'

const useMainLayoutState = () => {
    const [mobileOpen, setMobileOpen] = React.useState<boolean>(false);
    const [sidebarCollapsed, setSidebarCollapsed] = React.useState<boolean>(false);

    return { mobileOpen, setMobileOpen, sidebarCollapsed, setSidebarCollapsed }
}

export default useMainLayoutState